import { createFileRoute } from "@tanstack/react-router";

import ResetPasswordPage from "@/admin/forgot-password/reset/page";

export const Route = createFileRoute("/forgot-password_/reset")({
    component: RouteComponent,
});

function RouteComponent() {
    return <ResetPasswordPage />;
}
